import {
  createRootRouteWithContext,
  Outlet,
  useRouter,
  type NavigateOptions,
  type ToOptions,
} from "@tanstack/react-router";
import { GlimmProvider } from "glimm/react";
import { RouterProvider } from "react-aria-components";
import { Toaster } from "../components/ui/toast.tsx";
import type { RouterContext } from "../router.ts";

// React Aria links (`href` on Intent UI's Link, SidebarItem, Menu items) navigate through the
// TanStack router instead of reloading the page.
declare module "react-aria-components" {
  interface RouterConfig {
    routerOptions: Omit<NavigateOptions, keyof ToOptions>;
  }
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: Root,
  notFoundComponent: () => <p>Not found.</p>,
});

function Root() {
  const router = useRouter();
  return (
    <RouterProvider navigate={(href, options) => router.navigate({ ...options, href })}>
      {/* The sweep that reveals smart search results: top to bottom, under the search popover
          (z-50) as it closes, over the page. Skipped under reduced motion. Azure: the preset
          closest to the brand blue. */}
      <GlimmProvider palette="azure" direction="ttb" zIndex={45}>
        <Outlet />
      </GlimmProvider>
      <Toaster />
    </RouterProvider>
  );
}
